import React from 'react';
import styles from './styles.module.scss';
import ReviewStars from './ReviewStars';

const Reviews = ({ spaceData, t }) => {
  // Extract ratings for cleaner code
  const {
    note_avg,
    quality_price_avg,
    location_avg,
    quality_services_avg,
    equipments_avg
  } = spaceData;

  // Array of rating items for cleaner rendering
  const ratingCategories = [
    { key: 'quality_price_avg', title: t("space.ratingsQualityPrice"), value: quality_price_avg },
    { key: 'location_avg', title: t("space.ratingsLocation"), value: location_avg },
    { key: 'quality_services_avg', title: t("space.ratingsServices"), value: quality_services_avg },
    { key: 'equipments_avg', title: t("space.ratingsEquipments"), value: equipments_avg }
  ];

  // Filter out undefined/null ratings
  const validRatingCategories = ratingCategories.filter(category => category.value);

  // If no ratings at all, return null
  if (!note_avg && validRatingCategories.length === 0) {
    return null;
  }

  return (
    <div className={styles.reviewsSection}>
      <div className={styles.sectionBody}>
      
        {/* Detailed Ratings */}
        {validRatingCategories.length > 0 && (
          <div className={styles.reviewStarsMore}>
              {note_avg && (
            <ReviewStars
              title={t("space.global-rating")}
              rating={note_avg}
              size="large"
            />
        )}
            {validRatingCategories.map((category) => (
              <div 
                key={category.key}
                className={styles.reviewStarsContainer}
              >
                <ReviewStars
                  title={category.title}
                  rating={category.value}
                  size="small"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Reviews;